import { render, staticRenderFns } from "./InvoicingDetail.vue?vue&type=template&id=c2b657ee&scoped=true&"
import script from "./InvoicingDetail.vue?vue&type=script&lang=js&"
export * from "./InvoicingDetail.vue?vue&type=script&lang=js&"
import style0 from "./InvoicingDetail.vue?vue&type=style&index=0&id=c2b657ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b657ee",
  null
  
)

export default component.exports